import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";
import PointsTableHading from "./PointsTableHeading";
import PointsTableItem from "./PointsTableItem";
import NewsRequests from "services/news";

const PointsTable = ({ searchStr }) => {
  const { points, pointsCurrentPage, pointsTotalPages } = useSelector(
    ({ news }) => news
  );
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    if (searchStr) {
      dispatch(NewsRequests.getAllPoints(value, searchStr));
    } else {
      dispatch(NewsRequests.getAllPoints(value, ""));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {points && points.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <PointsTableHading />
          </TableHead>
          <TableBody>
            {points.map((item) => (
              <PointsTableItem data={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {points.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={pointsTotalPages}
            color="primary"
            page={pointsCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default PointsTable;
